import React from "react";
import { POPUP_TYPES } from "./helpers";
import SelectTemplatePopupWithContext from "../popups/SelectTemplatePopup";
import SelectCategoryPopup from "../popups/SelectCategoryPopup";
import SelectFeaturedProductPopup from "../popups/SelectFeaturedProductPopup";
import SaveTemplatePopup from "../popups/SaveTemplatePopup";
import TemplateWarnPopup from "../popups/TemplateWarnPopup";
import { PublicViewTemplate } from "../../../models/PublicViewTemplate";
import { SelectedThemeAndTemplateData } from "../popups/SelectTemplatePopup/TemplateTabs";
import { ITemplateData } from "../../../interfaces/PublicViewTemplateData";

interface StorefrontPopupsProps {
  showPopup: string;
  setShowPopup: (showPopup: string) => void;
  layouts: SelectedThemeAndTemplateData[];
  templateData: ITemplateData;
  selectedTheme: SelectedThemeAndTemplateData;
  selectedTemplate: SelectedThemeAndTemplateData;
  themeName: string;
  popUpConfig: { bannerOnHover: boolean };
  entityId: string;
  entityLayoutId: string;
  entityType: string;
  orderId: string;
  onDiscardPublicViewTemplateChanges: (
    parent_id: string,
    parent_type: string,
    reload_order_id: string
  ) => void;
}

const StorefrontPopups: React.FC<StorefrontPopupsProps> = ({
  showPopup,
  setShowPopup,
  layouts,
  templateData,
  selectedTheme,
  selectedTemplate,
  themeName,
  popUpConfig,
  entityId,
  entityLayoutId,
  entityType,
  orderId,
  onDiscardPublicViewTemplateChanges,
}) => {
  return (
    <>
      {showPopup === POPUP_TYPES.SELECT_THEME && (
        <SelectTemplatePopupWithContext
          onClose={() => setShowPopup("")}
          layouts={layouts}
          selectedTheme={selectedTheme}
          selectedTemplate={selectedTemplate}
        />
      )}
      {showPopup === POPUP_TYPES.SELECT_CATEGORIES_IMAGE && (
        <SelectCategoryPopup
          onClose={() => setShowPopup("")}
          themeName={themeName}
          showCategoryTitle={+templateData.categorytitle === 1}
          popupConfig={popUpConfig}
        />
      )}
      {showPopup === POPUP_TYPES.SELECT_FEATURED_IMAGE && (
        <SelectFeaturedProductPopup
          onClose={() => setShowPopup("")}
          templateData={templateData}
        />
      )}
      {showPopup === POPUP_TYPES.SAVE_TEMPLATE && (
        <SaveTemplatePopup
          onClose={() => setShowPopup("")}
          entityId={entityId}
          entityLayoutId={entityLayoutId}
          entityType={entityType}
        />
      )}
      {showPopup === POPUP_TYPES.TEMPLATE_WARN && (
        <TemplateWarnPopup
          onClose={() => setShowPopup("")}
          onDiscardChanges={() => {
            const reloadOrderId =
              selectedTemplate &&
              [
                PublicViewTemplate.CATEGORIES_CAROUSEL,
                PublicViewTemplate.LEFT_NAV_HERO_IMAGE,
              ].includes(selectedTheme?.public_view_template_name)
                ? orderId
                : null;
            onDiscardPublicViewTemplateChanges(
              entityId,
              entityType,
              reloadOrderId
            );
            setShowPopup(POPUP_TYPES.SELECT_THEME);
          }}
          onSaveAsTemplate={() => {
            setShowPopup(POPUP_TYPES.SELECT_THEME);
          }}
        />
      )}
    </>
  );
};

export default StorefrontPopups;
